var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, disabled: "", "label-width": "80px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "姓名" } },
            [
              _c("el-input", {
                attrs: { disabled: "", placeholder: "请输入姓名" },
                on: {
                  input: function ($event) {
                    return _vm.change($event)
                  },
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "请假时间" } },
            [
              _c("el-date-picker", {
                attrs: {
                  format: "yyyy-MM-dd HH:mm",
                  "value-format": "yyyy-MM-dd HH:mm",
                  type: "datetimerange",
                  "range-separator": "至",
                  "start-placeholder": "请假开始日期",
                  "end-placeholder": "请假结束日期",
                },
                on: {
                  input: function ($event) {
                    return _vm.change($event)
                  },
                },
                model: {
                  value: _vm.form.leaveDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "leaveDate", $$v)
                  },
                  expression: "form.leaveDate",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "请假类型" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请输入请假类型" },
                  model: {
                    value: _vm.form.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "type", $$v)
                    },
                    expression: "form.type",
                  },
                },
                [
                  _vm._l(_vm.leaveTypeOptionList, function (item) {
                    return [
                      _c("el-option", {
                        attrs: { value: item.dictValue, label: item.dictLabel },
                      }),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "请假事由" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入请假事由" },
                on: {
                  input: function ($event) {
                    return _vm.change($event)
                  },
                },
                model: {
                  value: _vm.form.reason,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "reason", $$v)
                  },
                  expression: "form.reason",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }